import { createRouter, createWebHashHistory } from 'vue-router'
import login from '../views/login.vue'

const routes = [{
  path: '/',
  name: 'login',
  component: login
},
{
  path: '/layout',
  name: 'layout',
  component: () => import( /* webpackChunkName: "layout" */ '../views/layout.vue'),
  redirect: '/Home',
  children: [{
    path: '/Home',
    name: 'Home',
    component: () => import(/* webpackChunkName: "Home" */ '../views/homePage.vue')
  }, {
    path: '/departmentYearStat',
    name: 'departmentYearStat',
    component: () => import(/* webpackChunkName: "report" */ '../views/report/departmentYearStat.vue')
  }, {
    path: '/employeeYearStat',
    name: 'employeeYearStat',
    component: () => import(/* webpackChunkName: "report" */ '../views/report/employeeYearStat.vue')
  }, {
    path: '/personalInfo',
    name: 'personalInfo',
    component: () => import(/* webpackChunkName: "personalInfo" */ '../views/personalInfo/personalInfo.vue')
  }, {
    path: '/department',
    name: 'department',
    component: () => import(/* webpackChunkName: "Home" */ '../views/department.vue')
  }, {
    path: '/dept_center',
    name: 'dept_center',
    component: () => import(/* webpackChunkName: "dept_center" */ '../views/dept_center.vue')
  }, {
    path: '/payroll',
    name: 'payroll',
    component: () => import(/* webpackChunkName: "payroll" */ '../views/payroll.vue')
  }, {
    path: '/report-1',
    name: 'report-1',
    component: () => import(/* webpackChunkName: "personalInfo" */ '../views/report/report-1.vue')
  }, {
    path: '/report-2',
    name: 'report-2',
    component: () => import(/* webpackChunkName: "personalInfo" */ '../views/report/report-2.vue')
  }, {
    path: '/report-3',
    name: 'report-3',
    component: () => import(/* webpackChunkName: "personalInfo" */ '../views/report/report-3.vue')
  }, {
    path: '/report-3-print',
    name: 'report-3-print',
    component: () => import(/* webpackChunkName: "personalInfo" */ '../views/report/report-3-print.vue')
  }, {
    path: '/report-4',
    name: 'report-4',
    component: () => import(/* webpackChunkName: "personalInfo" */ '../views/report/report-4.vue')
  }, {
    path: '/passwordChange',
    name: 'passwordChange',
    component: () => import(/* webpackChunkName: "passwordChange" */ '../views/account/passwordChange.vue')
  }, {
    path: '/user',
    name: 'user',
    component: () => import(/* webpackChunkName: "user" */ '../views/account/user.vue')
  }, {
    path: '/jobGrade',
    name: 'jobGrade',
    component: () => import(/* webpackChunkName: "user" */ '../views/settings/jobGrade.vue')
  }, {
    path: '/mealGrade',
    name: 'mealGrade',
    component: () => import(/* webpackChunkName: "user" */ '../views/settings/mealGrade.vue')
  }, {
    path: '/insureGrade',
    name: 'insureGrade',
    component: () => import(/* webpackChunkName: "user" */ '../views/settings/insureGrade.vue')
  }, {
    path: '/insureCompany',
    name: 'insureCompany',
    component: () => import(/* webpackChunkName: "user" */ '../views/settings/insureCompany.vue')
  }, {
    path: '/sysSetting',
    name: 'sysSetting',
    component: () => import(/* webpackChunkName: "user" */ '../views/settings/sysSetting.vue')
  }]
}
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
